import { get } from 'lodash';
import {
  convertSpecificError,
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from 'src/error/code';
import {
  EnumCollapseId,
  //generateFooterFooterNotes,
  // generateFooterFooterMenu,
  fixedCollapse,
  generateFooterLanguageSelector,
  generateFooterLocationSelector,
  generateFooterSocialMedia,
  generateFooterStyle,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import {
  addDraggableId,
  randomNumber,
  reduxUpdatedStatusControl,
} from 'src/tools/helper';

export const errKey = {
  locationSelectorTitle: 'locationSelectorTitle',
  locationSelectorOptionTitle: 'locationSelectorOptionTitle',
  locationSelectorOptionLink: 'locationSelectorOptionLink',
  languageSelectorTitle: 'languageSelectorTitle',
  socialMediaSelectorTitle: 'socialMediaSelectorTitle',
};

const validateLocationSelector = (data, isPrimary?) => {
  const { title, locationOptions } = data;
  const specificErr = {
    [errKey.locationSelectorTitle]: [],
    ...(locationOptions || []).reduce((pre, now) => {
      const {
        //title, linkLibrary ,
        draggableId,
      } = now;
      return {
        ...pre,
        [`${errKey.locationSelectorOptionTitle}${draggableId}`]: [],
        [`${errKey.locationSelectorOptionLink}${draggableId}`]: [],
      };
    }, {}),
  };
  if (!title) {
    specificErr[errKey.locationSelectorTitle].push(errCodesMap[999999]);
  }
  (locationOptions || []).forEach((item) => {
    const { title, linkLibrary, draggableId } = item || {};
    if (!title) {
      specificErr[`${errKey.locationSelectorOptionTitle}${draggableId}`].push(
        errCodesMap[999999],
      );
    }
    if (!get(linkLibrary, 'linkType') && isPrimary) {
      specificErr[`${errKey.locationSelectorOptionLink}${draggableId}`].push(
        errCodesMap[999999],
      );
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateLanguageSelector = (data, isPrimary?) => {
  const { title } = data || {};
  const specificErr = {
    [errKey.languageSelectorTitle]: [],
  };
  if (!title) {
    specificErr[errKey.languageSelectorTitle].push(errCodesMap[999999]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateSocialMedia = (data, isPrimary?) => {
  const { title } = data || {};
  const specificErr = {
    [errKey.socialMediaSelectorTitle]: [],
  };
  if (!title) {
    specificErr[errKey.socialMediaSelectorTitle].push(errCodesMap[999999]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export {
  validateLocationSelector,
  validateLanguageSelector,
  validateSocialMedia,
};
export { convertDataFromServerToRedux, convertDataFromReduxToServer };

const convertDataFromServerToRedux = (data, isPrimary?) => {
  const _footerStyle = generateFooterStyle();
  const _locationSelector = generateFooterLocationSelector();
  const _languageSelector = generateFooterLanguageSelector();
  const _socialMediaMenu = generateFooterSocialMedia();
  //const _footerMenu = generateFooterFooterMenu();
  //const _footerNotes = generateFooterFooterMenu();
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    footerStyle,
    locationSelector,
    languageSelector,
    socialMediaMenu,
    footerMenu, //==>navigationGroups 转换 array 取 第一位
    footerNotes,
    modifiedDate,
    createdDate,
    salesChannelUuid,
  } = data;
  const _isNew = modifiedDate === createdDate;
  const collapseOpen = generateCollapseOpen(fixedCollapse);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    fixedCollapse,
    !_isNew,
  );

  const { locationOptions } = locationSelector || {};
  const __locationSelector = {
    ..._locationSelector,
    ...(locationSelector || {}),
    locationOptions: addDraggableId(locationOptions || []),
  };

  const { socialMediaList, title } = socialMediaMenu || {};
  const _title = _socialMediaMenu.title;
  const __socialMediaMenu = {
    ..._socialMediaMenu,
    ...(socialMediaMenu || {}),
    title: title || _title,
    socialMediaList: addDraggableId(socialMediaList || []),
  };

  const {
    footerMenuColumn1,
    footerMenuColumn2,
    footerMenuColumn3,
    footerMenuColumn4,
    footerMenuColumn5,
  } = footerMenu || {};

  const transformCol = (col) => {
    return (col || []).map((i) => {
      const draggableId = get(i, 'draggableId');
      const navUuid = get(i, 'navigationGroups.0.uuid');
      if (draggableId) {
        if (navUuid) {
          return { ...i, draggableId, navigationGroups: navUuid };
        } else {
          return { ...i, draggableId, navigationGroups: null };
        }
      } else {
        const id = randomNumber();
        if (navUuid) {
          return { ...i, draggableId: id, navigationGroups: navUuid };
        } else {
          return { ...i, draggableId: id, navigationGroups: null };
        }
      }
    });
  };
  const __footerMenu = {
    footerMenuColumn1: transformCol(footerMenuColumn1),
    footerMenuColumn2: transformCol(footerMenuColumn2),
    footerMenuColumn3: transformCol(footerMenuColumn3),
    footerMenuColumn4: transformCol(footerMenuColumn4),
    footerMenuColumn5: transformCol(footerMenuColumn5),
  };

  if (hasError) {
    let flag = false;
    const locationSelectorSettingErr = validateLocationSelector(
      __locationSelector,
      isPrimary,
    );
    if (locationSelectorSettingErr.hasError) {
      collapseErrorMsgDisplay[EnumCollapseId.locationSelector].hasError = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.locationSelector] = true;
      }
    }
    const languageSelectorSettingErr = validateLanguageSelector(
      languageSelector,
      isPrimary,
    );
    if (languageSelectorSettingErr.hasError) {
      collapseErrorMsgDisplay[EnumCollapseId.languageSelector].hasError = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.languageSelector] = true;
      }
    }
    const socialMediaMenuSettingErr = validateSocialMedia(
      __socialMediaMenu,
      isPrimary,
    );
    if (socialMediaMenuSettingErr.hasError) {
      collapseErrorMsgDisplay[EnumCollapseId.socialMedia].hasError = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.socialMedia] = true;
      }
    }
  }

  // console.log('loaded data', {
  //   hasError,
  //   collapseErrorMsgDisplay,
  //   collapseOpen,
  //   contentUuid,
  //   salesChannelContent: salesChannelContent || {},
  //   salesChannelName,
  //   uuid,
  //   modifiedDate,
  //   createdDate,
  //   footerStyle: footerStyle || _footerStyle,
  //   locationSelector: __locationSelector,
  //   languageSelector: languageSelector || _languageSelector,
  //   socialMediaMenu: __socialMediaMenu,
  //   footerMenu: __footerMenu,
  //   footerNotes: footerNotes || '',
  //   ...reduxUpdatedStatusControl,
  // });

  return {
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    footerStyle: footerStyle || _footerStyle,
    locationSelector: __locationSelector,
    languageSelector: languageSelector || _languageSelector,
    socialMediaMenu: __socialMediaMenu,
    footerMenu: __footerMenu,
    footerNotes: footerNotes || '',
    salesChannelUuid,
    ...reduxUpdatedStatusControl,
  };
};

const convertDataFromReduxToServer = (data) => {
  const {
    contentUuid,
    uuid,
    footerStyle,
    locationSelector,
    languageSelector,
    socialMediaMenu,
    footerMenu,
    footerNotes,
    salesChannelUuid,
  } = data;
  const {
    footerMenuColumn1,
    footerMenuColumn2,
    footerMenuColumn3,
    footerMenuColumn4,
    footerMenuColumn5,
  } = footerMenu || {};
  const transferFooterMenu = (col) => {
    return (col || []).map((i) => {
      const navUuid = get(i, 'navigationGroups');
      if (navUuid) {
        return { ...i, navigationGroups: [{ uuid: navUuid }] };
      }
      return i;
    });
  };
  const _footerMenu = {
    footerMenuColumn1: transferFooterMenu(footerMenuColumn1),
    footerMenuColumn2: transferFooterMenu(footerMenuColumn2),
    footerMenuColumn3: transferFooterMenu(footerMenuColumn3),
    footerMenuColumn4: transferFooterMenu(footerMenuColumn4),
    footerMenuColumn5: transferFooterMenu(footerMenuColumn5),
  };
  // console.log('submit', {
  //   contentUuid,
  //   uuid,
  //   footerStyle,
  //   locationSelector,
  //   languageSelector,
  //   socialMediaMenu,
  //   footerMenu: _footerMenu,
  //   footerNotes,
  // });
  return {
    contentUuid,
    uuid,
    footerStyle,
    locationSelector,
    languageSelector,
    socialMediaMenu,
    footerMenu: _footerMenu,
    footerNotes,
    salesChannelUuid,
  };
};
